import * as DayOne from "./dayOne";
import * as DayTwo from "./dayTwo"
import * as DayThree from "./dayThree"

export default [
    {
        background: DayOne.image,
        links: DayOne.default
    },
    {
        background: DayTwo.image,
        links: DayTwo.default
    },
    {
        background: DayThree.image,
        links: DayThree.default
    }
]